import {booleanAttribute, ChangeDetectionStrategy, Component, ContentChild, EventEmitter, HostBinding, Input, Output, TemplateRef, ViewChild} from "@angular/core";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";

import {TooltipComponentDirective, TooltipPosition} from "framework/ui/components/tooltip/tooltip.component";

@Component({
               selector       : "cs-tooltip-icon",
               templateUrl    : "./tooltip-icon.component.html",
               styleUrls      : ["./tooltip-icon.component.scss"],
               changeDetection: ChangeDetectionStrategy.OnPush,
               imports        : [
                   MatIconModule,
                   MatTooltipModule,
                   TooltipComponentDirective
               ]
           })
export class TooltipIconComponent
{
    @Input() tooltipText: string;
    @Input() tooltipPosition: TooltipPosition   = "top";
    @Input({transform: booleanAttribute}) disabled: boolean;
    @Input({transform: booleanAttribute}) triggerOnClick: boolean;
    @Input({transform: booleanAttribute}) scrollable: boolean;
    @Input() size: "small" | "medium" | "large" = "medium";

    @ContentChild(TemplateRef) tooltipTemplate: TemplateRef<any>;
    @ViewChild("tooltipRef") tooltipRef: TooltipComponentDirective;

    @HostBinding("class.cs-trigger-on-click") get isTriggerOnClick(): boolean
    {
        return this.triggerOnClick;
    }

    @Output() opened = new EventEmitter<void>();

    onIconClick(event: MouseEvent)
    {
        if (this.triggerOnClick)
        {
            event.stopPropagation();
            this.tooltipRef?.toggleTooltip();
        }
    }
}
